export var TypeRecipeCost;
(function (TypeRecipeCost) {
    TypeRecipeCost["ProductionInput"] = "ProductionInput";
    TypeRecipeCost["Seed"] = "seedbag";
    TypeRecipeCost["BuySeeds"] = "BuySeeds";
    TypeRecipeCost["ProductionCost"] = "productionCost";
    TypeRecipeCost["WaterCost"] = "WaterCost";
    TypeRecipeCost["FeedCost"] = "FeedCost";
    TypeRecipeCost["PremiumFeedCost"] = "PremiumFeedCost";
})(TypeRecipeCost || (TypeRecipeCost = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/balancing/TypeRecipeCost.ts
// module id = 819
// module chunks = 3